import { render, staticRenderFns } from "./orderList3.vue?vue&type=template&id=3a922427&scoped=true&"
import script from "./orderList3.vue?vue&type=script&lang=js&"
export * from "./orderList3.vue?vue&type=script&lang=js&"
import style0 from "./orderList3.vue?vue&type=style&index=0&id=3a922427&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a922427",
  null
  
)

export default component.exports